const defaultSettings = {
  title: "DashSour",
  theme: "dark",
  ADMIN_ROLE: "ROLE_ADMIN"
}


export default defaultSettings;
